/**
 * @generated SignedSource<<6a5077558c1d2e63d07f0d0b753a4ddb>>
 * @relayHash e8cb7efb3cdfdae512bbed1951707027
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2e7d72e823159dd14bd1a7ddc28ad2a6f25785403e2f3a255e76f76d69af2b34

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2e7d72e823159dd14bd1a7ddc28ad2a6f25785403e2f3a255e76f76d69af2b34",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
